var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',{attrs:{"type":"stacked","message":_vm.message}},[_c('template',{slot:"primary"},[_c('input',{attrs:{"type":"text","placeholder":"Enter a number"},domProps:{"value":_vm.numCharacters},on:{"input":_vm.onInput}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }